export const REPORT_TABS = {
  OVERVIEW: 'overview',
  FUNNEL: 'funnel',
  FLOW: 'flow',
};

export const REPORT_TAB_ORDER = [
  REPORT_TABS.OVERVIEW,
  REPORT_TABS.FUNNEL,
  REPORT_TABS.FLOW,
];

// Tabs that reference specific steps and therefore require a single funnel.
export const BOARD_SCOPED_TABS = [REPORT_TABS.FUNNEL, REPORT_TABS.FLOW];

export const TIMESERIES_METRICS = [
  'throughput',
  'deals_won',
  'deals_lost',
  'deals_created',
];
export const DEFAULT_TIMESERIES_METRIC = 'throughput';

export const TIMESERIES_GROUP_BY = ['day', 'week', 'month'];
export const DEFAULT_GROUP_BY = 'day';

// The CFD reuses the same day/week/month granularity as the throughput chart.
export const CFD_GROUP_BY = TIMESERIES_GROUP_BY;
export const DEFAULT_CFD_GROUP_BY = 'day';

export const DEFAULT_RANGE_DAYS = 30;

export const ALL_BOARDS_VALUE = 'all';
export const ALL_AGENTS_VALUE = 'all';
export const ALL_INBOXES_VALUE = 'all';

// Reports downloadable as CSV per tab. `report` is the API endpoint segment; `labelKey`
// is an i18n key under KANBAN.REPORTS for the export menu entry.
export const EXPORTABLE_REPORTS = {
  [REPORT_TABS.OVERVIEW]: [
    { report: 'summary', labelKey: 'EXPORT.SUMMARY' },
    { report: 'timeseries', labelKey: 'THROUGHPUT.TITLE' },
    { report: 'agent_performance', labelKey: 'LEADERBOARD.TITLE' },
  ],
  [REPORT_TABS.FUNNEL]: [{ report: 'funnel', labelKey: 'FUNNEL.TITLE' }],
  [REPORT_TABS.FLOW]: [
    { report: 'cfd', labelKey: 'CFD.TITLE' },
    { report: 'aging', labelKey: 'AGING.TITLE' },
    { report: 'stage_durations', labelKey: 'DURATIONS.TITLE' },
  ],
};

// Primary bar color for time-series charts, matching the brand blue the native Chatwoot
// reports use for their charts so the report surface stays visually consistent.
export const CHART_PRIMARY_COLOR = 'rgb(31, 147, 255)';

// Used when a step has no color so charts/legends stay legible.
export const FALLBACK_STEP_COLORS = [
  '#3B82F6',
  '#8B5CF6',
  '#EC4899',
  '#F59E0B',
  '#10B981',
  '#06B6D4',
  '#EF4444',
  '#64748B',
];

export const stepColor = (color, index) =>
  color || FALLBACK_STEP_COLORS[index % FALLBACK_STEP_COLORS.length];
